'use es6';

import * as CacheKeys from 'reference-resolvers/constants/CacheKeys';
import createSimpleCachedReferenceResolver from 'reference-resolvers/lib/createSimpleCachedReferenceResolver';
import {
  createGetBusinessUnitDropdownOptions,
  getBusinessUnitDropdownOptions,
} from '../api/BusinessUnitDropdownAPI';

export const createBusinessUnitDropdownReferenceResolver = (options) =>
  createSimpleCachedReferenceResolver({
    cacheKey: CacheKeys.BUSINESS_UNIT_DROPDOWN,
    createFetchData: ({ httpClient }) =>
      createGetBusinessUnitDropdownOptions({
        httpClient,
        portalId: options?.portalId,
      }),
    fetchData: getBusinessUnitDropdownOptions,
    ...options,
  });

export default createBusinessUnitDropdownReferenceResolver();
